// extracted by mini-css-extract-plugin
export default {"root":"wpM1hs"};